var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMembersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#007EFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9C3.8 9 2 7.2 2 5V4c0-2.2 1.8-4 4-4s4 1.8 4 4v1c0 2.2-1.8 4-4 4zM4 11c-2.8 0-4-.199-4 2.601S2.24 16 3.859 16H7v-5H4zM13 10L11 10 11 12 9 12 9 14 11 14 11 16 13 16 13 14 15 14 15 12 13 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMembersIcon);
export default __webpack_public_path__ + "static/media/addMembersIcon.17b824960db926f25a25e6ca8246c62d.svg";
export { ForwardRef as ReactComponent };